<template>
  <div class="topBar">
    <div class="bar-content">
<img class="logo-img" src="@/assets/images/home/logo.png"/>
    <div class="barSelect">
        <div v-for="(item, index) in itemLists"
        :key="index"
        @click="clickItem(index, item.routePath)"
        :class="itemSelectIndex == index ? 'bar-item select-bg' : 'bar-item'">{{item.name}}</div>
    </div>
    <!--
    <div class="search-input">
      <img src="@/assets/images/home/icon_search.png" />
      <span>Search...</span>
    </div>
     -->
     <div class="search-input">
     </div>
    <!-- notif -->
    <!-- <div class="notif-container">
      <div>5</div>
      <img src="@/assets/images/home/notif.png" />
    </div> -->
    <!-- avator -->

    <v-hover close-delay="300" v-slot="{ hover }">
      <div>
        <div class="avator-container">
      <!-- <img src="@/assets/images/home/avatar_bar.png" /> -->
      <span>{{userInfo.email}}</span>
    </div>
    <div class="user-info" v-if="hover">
      <div class="info-top">
        <!-- <img class="user-avator" src="@/assets/images/home/avatar_bar.png" /> -->
        <div class="info-top-detail">
          <span>{{userInfo.name}}</span>
          <!-- <div>
            <span>12777777777</span>
              <img src="@/assets/images/home/userinfo_phone.png" alt="">
              <img src="@/assets/images/home/userinfo_video.png" alt="">
          </div> -->

        </div>

      </div>
        <div class="user-line"></div>
        
        <!--  -->
        <div class="info-item" @click="updatePwd">
          <img src="@/assets/images/home/info_setting.png" alt="">
          <span>{{$t('common.updatePwd')}}</span>
        </div>
        <!--  -->
        <div class="info-item" @click="changeLang">
          <img src="@/assets/images/home/lang_change.png" alt="">
          <span>English/中文</span>
        </div>
        <!-- 
        <div v-if="is_ga === 0" class="info-item" @click="googleOpen">
          <img src="@/assets/images/home/userinfo_video.png" alt="">
          <span>{{$t('Home.bindGoogle')}}</span>
        </div> -->
        <div class="info-item" @click="logoutClick">
          <img src="@/assets/images/home/info_logout.png" alt="">
          <span>{{$t('common.loginout')}}</span>
        </div>
        <!--  -->
    </div>
      </div>
    </v-hover>
    </div>
<!--  -->
    <div class="dialog-fixed" v-if="showPwdDiag">
      <el-dialog
        title=""
        :visible.sync="showPwdDiag"
        :modal="false"
        width="532px">
        <div class="dialog-content">
          <div class="dialog-title">{{$t('common.updatePwd')}}</div>
        <loginInput
         :label="$t('updatePwd.userName')"
         inputStyle="margin-bottom: 8px;"
         realInputStyle="height: 40px;"
         :inputValue="updatePwdUsername"
         disabled
          />
        <loginInput
         :label="$t('updatePwd.oldPwd')"
         inputStyle="margin-bottom: 8px;"
         realInputStyle="height: 40px;"
         @changeInput="e => oldPassword = e"
         type="password"
          />
        <loginInput
         :label="$t('updatePwd.newLoginPwd')"
         inputStyle="margin-bottom: 8px;"
         realInputStyle="height: 40px;"
         @changeInput="e => newPassword = e"
         type="password"
          />
        <loginInput
         :label="$t('updatePwd.confirmPwd')"
         inputStyle="margin-bottom: 8px;"
         realInputStyle="height: 40px;"
         @changeInput="e => confirmPassword = e"
         type="password"
          />
          <div class="dialog-btn">
            <div @click="commitclick">{{$t('certManage.commit')}}</div>
          </div>
        </div>
      </el-dialog>
    </div>

      <el-dialog
        title=""
        :visible.sync="showGADiag"
        :modal="false"
        width="80%"
        center
        >
        <div>
          <h2>绑定谷歌验证器</h2>
          <h3>使用说明：</h3>
          <h4>步骤一：</h4>
          <p>手机下载安装Google Authenticator。</p>
              <el-row type="flex" justify="center">
                  <el-col :span="8">
                    <p align="center">
                      <img src="@/assets/images/home/ios.png" width="200" height="200"><br>Ios扫描下载
                    </p>
                  </el-col>
                  <el-col :span="8">
                    <p align="center">
                      <img src="@/assets/images/home/android.png" width="200" height="200"><br>安卓扫描下载
                    </p>
                  </el-col>
              </el-row>
          <h4>步骤二：</h4>
          <p>软件安装完成后，选择开始设置-扫描条形码，来扫描本页面的二维码，扫描成功后，您手机里的谷歌验证器会生成一个与您账户对应的六位动态密码，每30秒变化一次。</p>
          <h4>步骤三：</h4>
          <p>之后您每次提现时都需要输入谷歌验证码，无论手机是否连接网络都可以使用。在允许时间内输入有效数字，保证了账户安全。
          </p>
          <div class="my-line"></div>
          <div style="margin-top: 15px" align="center">

          <p align="center">
            <b>本页面刷新后二维码会重置，请重新扫描</b>
            <br>
            <b>如果图片无法显示或者无法扫描，请在手机登录器中手动输入: </b> <b style="color:red"> {{this.secret }} </b>
            <br><br>
            <qrcode-vue :value="codeurl" size="220"/> 

          </p>
            <el-input placeholder="请输入扫描后手机显示的6位验证码" minlength="6" maxlength="6" clearable v-model="onecode">
            </el-input>
            <el-button style="margin-top: 15px" @click="googleCommit">立即绑定</el-button>
            <el-button style="margin-top: 15px" @click="showGADiag=false">{{$t('allDomain.cancel')}}</el-button>
          </div>

        </div>
      </el-dialog>



<!--  -->
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import { rmToken } from '@/utils/storge';
import { logout, getUserInfo, updatePwd, apiGoogleCodes, apiGoogleBinds } from '@/service/requestRes';

export default {
  components: {
    QrcodeVue,
  },  
  props: {
    itemLists: { type: Array, default: () => [] },
  },
  data() {
    return {
      itemSelectIndex: 0,
      showPwdDiag: false,
      userInfo: {},
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      updatePwdUsername: '',
      showGADiag: false,
      is_ga: 0,
      secret: '',
      codeurl: '',
      onecode: ''
    };
  },
  created() {
    let index = 0;
    if (this.$route.path != '/') {
    this.itemLists && this.itemLists.forEach((item, i) => {
    const routePath = item.routePath;
    if ((this.$route.path).indexOf(routePath) != -1) {
      index = i;
      this.itemSelectIndex = i;
    }
    })
    }
    this.clickItem(index, this.$route.path || '/');

    getUserInfo().then((res) => {
      const { msg, code, data } = res;
      if (code === 1) {
        this.userInfo = data;
        this.is_ga = data.is_ga;
      } else {
      
       msg && this.$message({
          message: msg,
          type: 'error',
        });
      }
    });
  },
  methods: {
    clickItem(index, routePaht) {
      this.itemSelectIndex = index;
      this.$router.replace(routePaht);
    },
    logoutClick() {
      logout().then((res) => {
        const { msg, code } = res || {};
        if (code === 1) {
          rmToken();
          this.$router.replace('/login');
        } else {
          msg && this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    changeLang() {
      const { locale } = this.$i18n;
      if (locale === 'en_US') {
        this.$langSetup('zh_CN');
      } else {
        this.$langSetup('en_US');
      }
    },
    updatePwd() {
      this.showPwdDiag = true;
      this.updatePwdUsername = this.userInfo.email;
    },
    googleOpen() {
      this.showGADiag = true;
      this.onecode = '';
      apiGoogleCodes().then((res) => {
        const { msg, data, code } = res || {};
        if (code === 1) {
          this.codeurl = data.createSecret.codeurl;
          this.secret = data.createSecret.secret;
        } else {
          msg && this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
      
    },
    googleCommit() {
      apiGoogleBinds({
        code: this.onecode,
        token: this.secret
      }).then((res) => {
        const { msg, data, code } = res || {};
        if (code === 1) {
          this.is_ga = 1;
          this.$message({
            message: this.$t('common.success'),
            type: "success",
          });
        } else {
         msg && this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
      this.showGADiag = false;
    },       
    commitclick() {
      if (!this.oldPassword) {
        this.$message({
          message: this.$t('nav.tip1'),
          type: 'error',
        });
        return;
      }
      if (!this.newPassword) {
        this.$message({
          message: this.$t('nav.tip2'),
          type: 'error',
        });
        return;
      }
      if (this.confirmPassword !== this.newPassword) {
        this.$message({
          message: this.$t('nav.tip3'),
          type: 'error',
        });
        return;
      }
      this.showPwdDiag = false;
      updatePwd({ oldPassword: this.oldPassword, password: this.newPassword }).then((res) => {
        const { msg, code } = res || {};
        if (code === 1) {
          rmToken();
          this.$router.replace('/login');
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .topBar {
    width: 100vw;
    height: 60px;
    background-color: #333752;
    position: fixed;
    top: 0;
    z-index: 99;
    .bar-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .logo-img {
      margin-left: 13.8px;
      margin-right: 13.8px;
    }
    .barSelect {
      width: 770px;
      height: 100%;
      display: flex;
      .bar-item{
        width: 110px;
        color: white;
        font-size: 16px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-family: PingFangSC-Regular;
        cursor: pointer;
      }
      .select-bg {
        background-color: #4F81FF;
        height: 64px;
      }
    }

    .search-input {
      // width: 285px;
      width: 225px;
      height: 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      padding-left: 16px;
      margin-left: 23px;
      span {
        color: #5A607F;
        font-size: 14px;
      }
      img {
        width: 17px;
        height: 17px;
        margin-right: 12px;
      }
    }
    .notif-container {
      margin-left: 31px;
      position: relative;
      display: flex;
      align-items: center;
    }
    .notif-container :first-child {
      background-color: #1E5EFF;
      position: absolute;
      left: 13px;
      top: -5px;
      border-radius: 50%;
      color: white;
      width: 16px;
      height: 16px;
      line-height: 16px;
      text-align: center;
      font-size: 12px;
    }

    .avator-container {
      // margin-left: 33px;
      display: flex;
      align-items: center;
      margin-right: 24px;
      span {
        margin-left: 11px;
        font-size: 14px;
        color: #FFFFFF;
        letter-spacing: 0;
        font-family: Helvetica-Bold;
      }
    }
    .user-info {
      position: absolute;
      margin-top: 15px;
      right: 30px;
      width: 145px;
      height: 220px;
      background: #FFFFFF;
      box-shadow: 0 6px 24px 0 rgba(38,44,71,0.16);
      border-radius: 4px;
      padding: 20px 10px;
      .info-top {
        display: flex;
        .user-avator {
          width: 48px;
          height: 48px;
          border-radius: 4px;
        }
        .info-top-detail {
          margin-left: 8px;
          :nth-child(1) {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #131523;
            letter-spacing: 0;
            line-height: 24px;
          }
          :nth-child(2) {
            display: flex;
            align-items: center;
           span {
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #A1A7C4;
            letter-spacing: 0;
            line-height: 20px;
            margin-right: 15px;
           }
           img {
             width: 18px;
             margin-right: 10px;
           }
          }
        }

      }

      .user-line {
          width: 100%;
          height: 1px;
          background-color: #D7DBEC;
          margin-top: 17px;
          margin-bottom: 17px;
        }
     .info-item {
       height: 44px;
       width: 100%;
       font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5A607F;
      letter-spacing: 0;
      display: flex;
      align-items: center;
      span {
        margin-left: 5px;
      }
     }
     .info-item:hover {
       background-color: #ECF2FF;
       border-radius: 4px;
       font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #1E5EFF;
      letter-spacing: 0;
      cursor: pointer;
     }
    }

    .dialog-content {
      padding: 0 16px 16px 16px;
      margin-top: -20px;
      z-index: 99;
      // box-shadow: 0 0 30px 10px rgba(0, 0, 0, 0.6);
      :nth-child(1) {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #131523;
      }
      :nth-child(2) {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #131523;
        margin-top: 19px;
      }
      .dialog-btn {
            width: 100%;
            margin-top: 40px;
            display: flex;
            :first-child {
                padding:8px 35px;
                background: #D9E4FF;;
                border-radius: 4px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #1E5EFF;
                margin: 0 auto;
                cursor: pointer;
            }
      }
    }
  }

.my-line {
  width: 100%;
  height: 2px;
  background-color: #aaa;
  margin: 24px 0 24px 0;
}

  .dialog-fixed {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }
.dialog-title {
  text-align: center;
  font-size: 23px !important;
}
</style>
